import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      display: 'flex',
      alignItems: 'center',
      margin: theme.spacing(1, 0),
      gap: theme.spacing(1),

      '& > .MuiIconButton-root': {
        marginLeft: '-1.4rem',
      },

      '& > h3': {
        fontSize: '2.2rem',
      },
    },
    titleContainer: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(0.5),
      width: '100%',
      overflow: 'hidden',
      whiteSpace: 'nowrap',

      '& > h3': {
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
      },
    },
    fieldInfoContainer: {
      display: 'flex',
      width: '100%',
      justifyContent: 'space-between',
      flexWrap: 'wrap',
    },
    regionInfoContainer: {
      display: 'flex',
      flexDirection: 'row',
      gap: theme.spacing(0.5),
      alignItems: 'center',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
    },
    separator: {
      backgroundColor: '#00000080',
      width: '1px',
      height: '1.6rem',
    },
    subtitle: {
      fontSize: '1.2rem',
      fontWeight: 600,
      fontFamily: theme.typography.h1.fontFamily,
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
    },
    areaInfo: {
      fontSize: '1.2rem',
      fontWeight: 600,
      fontFamily: theme.typography.h1.fontFamily,

      '& > span': {
        fontWeight: 400,
      },
    },
  }),
)
